// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoItem-module__font-s-10___T0xOD {
  font-size: 10px !important;
}

.InfoItem-module__font-s-12___ZGjEv {
  font-size: 12px !important;
}

.InfoItem-module__font-s-13___QBdL0 {
  font-size: 13px !important;
}

.InfoItem-module__font-s-14___ee57K {
  font-size: 14px !important;
}

.InfoItem-module__font-s-15___CDKJL {
  font-size: 15px !important;
}

.InfoItem-module__font-s-16___zYvda {
  font-size: 16px !important;
}

.InfoItem-module__font-s-18___xoEVH {
  font-size: 18px !important;
}

.InfoItem-module__font-s-20___L3nUF {
  font-size: 20px !important;
}

.InfoItem-module__font-s-22___Xf3KC {
  font-size: 22px !important;
}

.InfoItem-module__font-s-28___yjjOj {
  font-size: 28px !important;
}

.InfoItem-module__font-w-400___onbe9 {
  font-weight: 400 !important;
}

.InfoItem-module__font-w-500___LW563 {
  font-weight: 500 !important;
}

.InfoItem-module__font-w-600___miNWb {
  font-weight: 600 !important;
}

.InfoItem-module__font-w-700___Gn4mF {
  font-weight: 700 !important;
}

.InfoItem-module__p-5___ThMEW {
  padding: 5px !important;
}

.InfoItem-module__p-12___THgPL {
  padding: 12px !important;
}

.InfoItem-module__p-16___QJCO1 {
  padding: 16px !important;
}

.InfoItem-module__p-30___DTlst {
  padding: 30px !important;
}

.InfoItem-module__p-b-0___MnjRe {
  padding-bottom: 0 !important;
}

.InfoItem-module__p-b-5___rBfLS {
  padding-bottom: 5px !important;
}

.InfoItem-module__p-b-10___tg3WH {
  padding-bottom: 10px !important;
}

.InfoItem-module__p-b-12___Aa9Qg {
  padding-bottom: 12px !important;
}

.InfoItem-module__p-b-16___YyzsB {
  padding-bottom: 16px !important;
}

.InfoItem-module__p-b-18___p5fx_ {
  padding-bottom: 18px !important;
}

.InfoItem-module__p-b-20___Y21zj {
  padding-bottom: 20px !important;
}

.InfoItem-module__p-b-25___eOyKA {
  padding-bottom: 25px !important;
}

.InfoItem-module__p-b-30___aOOP0 {
  padding-bottom: 30px !important;
}

.InfoItem-module__p-b-50___f0ili {
  padding-bottom: 50px !important;
}

.InfoItem-module__p-t-0___A2Ni0 {
  padding-top: 0 !important;
}

.InfoItem-module__p-t-12___c4WRq {
  padding-top: 12px !important;
}

.InfoItem-module__p-t-16___Nr_X9 {
  padding-top: 16px !important;
}

.InfoItem-module__p-t-18___xWTPx {
  padding-top: 18px !important;
}

.InfoItem-module__p-t-20___M3gjq {
  padding-top: 20px !important;
}

.InfoItem-module__p-t-30___j2q62 {
  padding-top: 30px !important;
}

.InfoItem-module__p-t-40___VUvAX {
  padding-top: 40px !important;
}

.InfoItem-module__p-t-50___C5kc1 {
  padding-top: 50px !important;
}

.InfoItem-module__p-l-20___IOFbw {
  padding-left: 20px !important;
}

.InfoItem-module__p-l-30___M1l2j {
  padding-left: 30px !important;
}

.InfoItem-module__p-l-40___BQtae {
  padding-left: 40px !important;
}

.InfoItem-module__p-r-16___fWjqC {
  padding-right: 16px !important;
}

.InfoItem-module__p-r-20___YoP7p {
  padding-right: 20px !important;
}

.InfoItem-module__p-r-30___kNQt0 {
  padding-right: 30px !important;
}

.InfoItem-module__p-r-50___N_bNT {
  padding-right: 50px !important;
}

.InfoItem-module__p-r-60___lKdAx {
  padding-right: 60px !important;
}

.InfoItem-module__m-b-1___B5UY3 {
  margin-bottom: 1px !important;
}

.InfoItem-module__m-b-2___J_vCh {
  margin-bottom: 2px !important;
}

.InfoItem-module__m-b-6___hCs6D {
  margin-bottom: 6px !important;
}

.InfoItem-module__m-b-8___IaGie {
  margin-bottom: 8px !important;
}

.InfoItem-module__m-b-10___TWu7t {
  margin-bottom: 10px !important;
}

.InfoItem-module__m-b-14___RyXNl {
  margin-bottom: 14px !important;
}

.InfoItem-module__m-b-16___eZbaH {
  margin-bottom: 16px !important;
}

.InfoItem-module__m-b-20___dyRmR {
  margin-bottom: 20px !important;
}

.InfoItem-module__m-b-22___Pvtq5 {
  margin-bottom: 22px !important;
}

.InfoItem-module__m-b-24____BN82 {
  margin-bottom: 24px !important;
}

.InfoItem-module__m-b-30___eeLDo {
  margin-bottom: 30px !important;
}

.InfoItem-module__m-b-32___ZwwwM {
  margin-bottom: 32px !important;
}

.InfoItem-module__m-b-40___aE_HH {
  margin-bottom: 40px !important;
}

.InfoItem-module__m-t-2___vRKIC {
  margin-top: 2px !important;
}

.InfoItem-module__m-t-3___Ll4ae {
  margin-top: 3px !important;
}

.InfoItem-module__m-t-4___f26gs {
  margin-top: 4px !important;
}

.InfoItem-module__m-t-5___FqnT5 {
  margin-top: 5px !important;
}

.InfoItem-module__m-t-8___CczRy {
  margin-top: 8px !important;
}

.InfoItem-module__m-t-10___F_3Fn {
  margin-top: 10px !important;
}

.InfoItem-module__m-t-15___aHjXa {
  margin-top: 15px !important;
}

.InfoItem-module__m-t-16___IIcCq {
  margin-top: 16px !important;
}

.InfoItem-module__m-t-20___Ckwzc {
  margin-top: 20px !important;
}

.InfoItem-module__m-t-22___cmzaD {
  margin-top: 22px !important;
}

.InfoItem-module__m-t-30___Sz_Sj {
  margin-top: 30px !important;
}

.InfoItem-module__m-t-32___rkiqA {
  margin-top: 32px !important;
}

.InfoItem-module__m-l-auto___cZjv1 {
  margin-left: auto !important;
}

.InfoItem-module__m-l-4___sVRC7 {
  margin-left: 4px !important;
}

.InfoItem-module__m-l-5___vm1yt {
  margin-left: 5px !important;
}

.InfoItem-module__m-l-6___wKodx {
  margin-left: 6px !important;
}

.InfoItem-module__m-l-8___YBM3u {
  margin-left: 8px !important;
}

.InfoItem-module__m-l-10___hDLPy {
  margin-left: 10px !important;
}

.InfoItem-module__m-l-16___mkpTx {
  margin-left: 16px !important;
}

.InfoItem-module__m-l-20___wBoZH {
  margin-left: 20px !important;
}

.InfoItem-module__m-l-24___ptXjp {
  margin-left: 24px !important;
}

.InfoItem-module__m-l-30___VbC3l {
  margin-left: 30px !important;
}

.InfoItem-module__m-l-35___Y4jxa {
  margin-left: 35px !important;
}

.InfoItem-module__m-l-40___Oisf4 {
  margin-left: 40px !important;
}

.InfoItem-module__m-r-8___B0XK4 {
  margin-right: 8px !important;
}

.InfoItem-module__m-r-10___qEcJL {
  margin-right: 10px !important;
}

.InfoItem-module__m-r-16___MoU01 {
  margin-right: 16px !important;
}

.InfoItem-module__m-r-20___uJqFR {
  margin-right: 20px !important;
}

.InfoItem-module__m-r-24___B_p2E {
  margin-right: 24px !important;
}

.InfoItem-module__m-r-30___fTnID {
  margin-right: 30px !important;
}

.InfoItem-module__m-r-40___uoleo {
  margin-right: 40px !important;
}

.InfoItem-module__border-r-3___blDZU {
  border-radius: 3px !important;
}

.InfoItem-module__border-r-4___YTul4 {
  border-radius: 4px !important;
}

.InfoItem-module__border-r-6___KUSx2 {
  border-radius: 6px !important;
}

.InfoItem-module__border-r-10___SeqbF {
  border-radius: 10px !important;
}

.InfoItem-module__border-r-12___zAXL8 {
  border-radius: 12px !important;
}

.InfoItem-module__border-r-16___UebZk {
  border-radius: 16px !important;
}

.InfoItem-module__border-r-50___E2rpX {
  border-radius: 50% !important;
}

.InfoItem-module__primary-border___wnzZa {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoItem-module__primary-border-b___JoJaq {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoItem-module__primary-border-t___kGc40 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoItem-module__primary-border-l___T11iK {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoItem-module__primary-border-r___uwcj8 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.InfoItem-module__secondary-border___p1uYl {
  border: 1px solid #637768;
}

.InfoItem-module__secondary-border-b___ex0cm {
  border-bottom: 1px solid #637768;
}

.InfoItem-module__secondary-border-t___xjwDD {
  border-top: 1px solid #637768;
}

.InfoItem-module__secondary-border-l___AAxWi {
  border-left: 1px solid #637768;
}

.InfoItem-module__secondary-border-r___YyWRP {
  border-right: 1px solid #637768;
}

.InfoItem-module__gap-0___BxA69 {
  gap: 0 !important;
}

.InfoItem-module__gap-2___UZDKN {
  gap: 2px !important;
}

.InfoItem-module__gap-4___gl2T4 {
  gap: 4px !important;
}

.InfoItem-module__gap-5___MgXZ1 {
  gap: 5px !important;
}

.InfoItem-module__gap-6___GhAB1 {
  gap: 6px !important;
}

.InfoItem-module__gap-8___QJTUT {
  gap: 8px !important;
}

.InfoItem-module__gap-10___xSj7X {
  gap: 10px !important;
}

.InfoItem-module__gap-12___OECbX {
  gap: 12px !important;
}

.InfoItem-module__gap-14___qyaRH {
  gap: 14px !important;
}

.InfoItem-module__gap-16___gJVPs {
  gap: 16px !important;
}

.InfoItem-module__gap-18___SFZVq {
  gap: 18px !important;
}

.InfoItem-module__gap-20___LUV3m {
  gap: 20px !important;
}

.InfoItem-module__gap-24___hNPcf {
  gap: 24px !important;
}

.InfoItem-module__gap-26___oGMCp {
  gap: 26px !important;
}

.InfoItem-module__gap-30___tHoB6 {
  gap: 30px !important;
}

.InfoItem-module__gap-32___zfpsq {
  gap: 32px !important;
}

.InfoItem-module__gap-40___AtefC {
  gap: 40px !important;
}

.InfoItem-module__gap-50___EeTiC {
  gap: 50px !important;
}

.InfoItem-module__flex-1___hCY0B {
  flex: 1;
}

.InfoItem-module__flex-none___Dzac5 {
  flex: none !important;
}

.InfoItem-module__flex-column___kG5g_ {
  display: flex;
  flex-direction: column !important;
}

.InfoItem-module__flex-row___z9AwR {
  display: flex;
  flex-direction: row !important;
}

.InfoItem-module__vertically-centered___BmYl4 {
  display: flex;
  align-items: center !important;
}

.InfoItem-module__horizontally-centered___IgM7R {
  display: flex;
  justify-content: center !important;
}

.InfoItem-module__horizontally-end___mDTqJ {
  display: flex;
  justify-content: end !important;
}

.InfoItem-module__vertically-start___aCrbC {
  display: flex;
  align-items: start !important;
}

.InfoItem-module__space-between___vMZbR {
  display: flex;
  justify-content: space-between !important;
}

.InfoItem-module__flex-wrap___Kf_Sd {
  flex-wrap: wrap !important;
}

.InfoItem-module__height-100___ZOjy0 {
  height: 100%;
}

.InfoItem-module__width-50___By_Uy {
  width: 50% !important;
}

.InfoItem-module__width-100___VWemy {
  width: 100%;
}

.InfoItem-module__cursor-pointer___L3dAE {
  cursor: pointer;
}

.InfoItem-module__cursor-not-allowed___j2rV6 {
  cursor: not-allowed !important;
}

.InfoItem-module__absolute-centered___clwzP {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.InfoItem-module__absolute___wfTak {
  position: absolute;
}

.InfoItem-module__relative___GEf6u {
  position: relative;
}

.InfoItem-module__fixed___M9UBk {
  position: fixed;
}

.InfoItem-module__visible___MqqTg {
  opacity: 1;
}

.InfoItem-module__invisible___qqrv0 {
  opacity: 0;
}

.InfoItem-module__col-90___G0MrI {
  width: 90% !important;
}

.InfoItem-module__col-auto___w7B8O {
  width: auto !important;
}

.InfoItem-module__medical-tabs___fyfhN {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.InfoItem-module__medical-table-new____Wi5W {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.InfoItem-module__medical-table-new____Wi5W:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.InfoItem-module__medical-table-new____Wi5W::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.InfoItem-module__medical-table-new____Wi5W::-webkit-scrollbar-track {
  display: none;
}
.InfoItem-module__medical-table-new____Wi5W.InfoItem-module__no-pagination___Gd49b {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.InfoItem-module__medical-table-new____Wi5W.InfoItem-module__no-pagination___Gd49b:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.InfoItem-module__medical-table-new____Wi5W.InfoItem-module__no-pagination___Gd49b::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.InfoItem-module__medical-table-new____Wi5W.InfoItem-module__no-pagination___Gd49b::-webkit-scrollbar-track {
  display: none;
}

.InfoItem-module__medical-table-empty___Q_JH2 {
  padding: 14px 40px !important;
}

.InfoItem-module__icon-btn___WXitQ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.InfoItem-module__search-icon___aLMM2 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.InfoItem-module__disable-select___sxnoY {
  user-select: none;
}

.InfoItem-module__break-word___CcD0N {
  word-break: break-word;
}

.InfoItem-module__popup-clear-btn___MXE82 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.InfoItem-module__scroll-m-b-20___vMCNW {
  scroll-margin-bottom: 20px;
}

.InfoItem-module__title___o39sw {
  color: #637768;
}

.InfoItem-module__content___vOAYA {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #375844;
}

.InfoItem-module__suffix___iKDWS {
  color: #c56836;
}

.InfoItem-module__tooltipIcon___q5m1C {
  width: 14px;
  height: 14px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/elements/InfoItem/InfoItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;ECFE,gBAAA;EACA,mBAAA;EACA,uBAAA;EDEA,cAAA;AAgqBF;;AA7pBA;EACE,cAAA;AAgqBF;;AA7pBA;EACE,WAAA;EACA,YAAA;AAgqBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.title {\n  color: get-color(greenNew, medium-dark);\n}\n\n.content {\n  @include clipped-text;\n  color: get-color(greenNew, dark);\n}\n\n.suffix {\n  color: get-color(orangeNew, dark);\n}\n\n.tooltipIcon {\n  width: 14px;\n  height: 14px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `InfoItem-module__font-s-10___T0xOD`,
	"fontS12": `InfoItem-module__font-s-12___ZGjEv`,
	"fontS13": `InfoItem-module__font-s-13___QBdL0`,
	"fontS14": `InfoItem-module__font-s-14___ee57K`,
	"fontS15": `InfoItem-module__font-s-15___CDKJL`,
	"fontS16": `InfoItem-module__font-s-16___zYvda`,
	"fontS18": `InfoItem-module__font-s-18___xoEVH`,
	"fontS20": `InfoItem-module__font-s-20___L3nUF`,
	"fontS22": `InfoItem-module__font-s-22___Xf3KC`,
	"fontS28": `InfoItem-module__font-s-28___yjjOj`,
	"fontW400": `InfoItem-module__font-w-400___onbe9`,
	"fontW500": `InfoItem-module__font-w-500___LW563`,
	"fontW600": `InfoItem-module__font-w-600___miNWb`,
	"fontW700": `InfoItem-module__font-w-700___Gn4mF`,
	"p5": `InfoItem-module__p-5___ThMEW`,
	"p12": `InfoItem-module__p-12___THgPL`,
	"p16": `InfoItem-module__p-16___QJCO1`,
	"p30": `InfoItem-module__p-30___DTlst`,
	"pB0": `InfoItem-module__p-b-0___MnjRe`,
	"pB5": `InfoItem-module__p-b-5___rBfLS`,
	"pB10": `InfoItem-module__p-b-10___tg3WH`,
	"pB12": `InfoItem-module__p-b-12___Aa9Qg`,
	"pB16": `InfoItem-module__p-b-16___YyzsB`,
	"pB18": `InfoItem-module__p-b-18___p5fx_`,
	"pB20": `InfoItem-module__p-b-20___Y21zj`,
	"pB25": `InfoItem-module__p-b-25___eOyKA`,
	"pB30": `InfoItem-module__p-b-30___aOOP0`,
	"pB50": `InfoItem-module__p-b-50___f0ili`,
	"pT0": `InfoItem-module__p-t-0___A2Ni0`,
	"pT12": `InfoItem-module__p-t-12___c4WRq`,
	"pT16": `InfoItem-module__p-t-16___Nr_X9`,
	"pT18": `InfoItem-module__p-t-18___xWTPx`,
	"pT20": `InfoItem-module__p-t-20___M3gjq`,
	"pT30": `InfoItem-module__p-t-30___j2q62`,
	"pT40": `InfoItem-module__p-t-40___VUvAX`,
	"pT50": `InfoItem-module__p-t-50___C5kc1`,
	"pL20": `InfoItem-module__p-l-20___IOFbw`,
	"pL30": `InfoItem-module__p-l-30___M1l2j`,
	"pL40": `InfoItem-module__p-l-40___BQtae`,
	"pR16": `InfoItem-module__p-r-16___fWjqC`,
	"pR20": `InfoItem-module__p-r-20___YoP7p`,
	"pR30": `InfoItem-module__p-r-30___kNQt0`,
	"pR50": `InfoItem-module__p-r-50___N_bNT`,
	"pR60": `InfoItem-module__p-r-60___lKdAx`,
	"mB1": `InfoItem-module__m-b-1___B5UY3`,
	"mB2": `InfoItem-module__m-b-2___J_vCh`,
	"mB6": `InfoItem-module__m-b-6___hCs6D`,
	"mB8": `InfoItem-module__m-b-8___IaGie`,
	"mB10": `InfoItem-module__m-b-10___TWu7t`,
	"mB14": `InfoItem-module__m-b-14___RyXNl`,
	"mB16": `InfoItem-module__m-b-16___eZbaH`,
	"mB20": `InfoItem-module__m-b-20___dyRmR`,
	"mB22": `InfoItem-module__m-b-22___Pvtq5`,
	"mB24": `InfoItem-module__m-b-24____BN82`,
	"mB30": `InfoItem-module__m-b-30___eeLDo`,
	"mB32": `InfoItem-module__m-b-32___ZwwwM`,
	"mB40": `InfoItem-module__m-b-40___aE_HH`,
	"mT2": `InfoItem-module__m-t-2___vRKIC`,
	"mT3": `InfoItem-module__m-t-3___Ll4ae`,
	"mT4": `InfoItem-module__m-t-4___f26gs`,
	"mT5": `InfoItem-module__m-t-5___FqnT5`,
	"mT8": `InfoItem-module__m-t-8___CczRy`,
	"mT10": `InfoItem-module__m-t-10___F_3Fn`,
	"mT15": `InfoItem-module__m-t-15___aHjXa`,
	"mT16": `InfoItem-module__m-t-16___IIcCq`,
	"mT20": `InfoItem-module__m-t-20___Ckwzc`,
	"mT22": `InfoItem-module__m-t-22___cmzaD`,
	"mT30": `InfoItem-module__m-t-30___Sz_Sj`,
	"mT32": `InfoItem-module__m-t-32___rkiqA`,
	"mLAuto": `InfoItem-module__m-l-auto___cZjv1`,
	"mL4": `InfoItem-module__m-l-4___sVRC7`,
	"mL5": `InfoItem-module__m-l-5___vm1yt`,
	"mL6": `InfoItem-module__m-l-6___wKodx`,
	"mL8": `InfoItem-module__m-l-8___YBM3u`,
	"mL10": `InfoItem-module__m-l-10___hDLPy`,
	"mL16": `InfoItem-module__m-l-16___mkpTx`,
	"mL20": `InfoItem-module__m-l-20___wBoZH`,
	"mL24": `InfoItem-module__m-l-24___ptXjp`,
	"mL30": `InfoItem-module__m-l-30___VbC3l`,
	"mL35": `InfoItem-module__m-l-35___Y4jxa`,
	"mL40": `InfoItem-module__m-l-40___Oisf4`,
	"mR8": `InfoItem-module__m-r-8___B0XK4`,
	"mR10": `InfoItem-module__m-r-10___qEcJL`,
	"mR16": `InfoItem-module__m-r-16___MoU01`,
	"mR20": `InfoItem-module__m-r-20___uJqFR`,
	"mR24": `InfoItem-module__m-r-24___B_p2E`,
	"mR30": `InfoItem-module__m-r-30___fTnID`,
	"mR40": `InfoItem-module__m-r-40___uoleo`,
	"borderR3": `InfoItem-module__border-r-3___blDZU`,
	"borderR4": `InfoItem-module__border-r-4___YTul4`,
	"borderR6": `InfoItem-module__border-r-6___KUSx2`,
	"borderR10": `InfoItem-module__border-r-10___SeqbF`,
	"borderR12": `InfoItem-module__border-r-12___zAXL8`,
	"borderR16": `InfoItem-module__border-r-16___UebZk`,
	"borderR50": `InfoItem-module__border-r-50___E2rpX`,
	"primaryBorder": `InfoItem-module__primary-border___wnzZa`,
	"primaryBorderB": `InfoItem-module__primary-border-b___JoJaq`,
	"primaryBorderT": `InfoItem-module__primary-border-t___kGc40`,
	"primaryBorderL": `InfoItem-module__primary-border-l___T11iK`,
	"primaryBorderR": `InfoItem-module__primary-border-r___uwcj8`,
	"secondaryBorder": `InfoItem-module__secondary-border___p1uYl`,
	"secondaryBorderB": `InfoItem-module__secondary-border-b___ex0cm`,
	"secondaryBorderT": `InfoItem-module__secondary-border-t___xjwDD`,
	"secondaryBorderL": `InfoItem-module__secondary-border-l___AAxWi`,
	"secondaryBorderR": `InfoItem-module__secondary-border-r___YyWRP`,
	"gap0": `InfoItem-module__gap-0___BxA69`,
	"gap2": `InfoItem-module__gap-2___UZDKN`,
	"gap4": `InfoItem-module__gap-4___gl2T4`,
	"gap5": `InfoItem-module__gap-5___MgXZ1`,
	"gap6": `InfoItem-module__gap-6___GhAB1`,
	"gap8": `InfoItem-module__gap-8___QJTUT`,
	"gap10": `InfoItem-module__gap-10___xSj7X`,
	"gap12": `InfoItem-module__gap-12___OECbX`,
	"gap14": `InfoItem-module__gap-14___qyaRH`,
	"gap16": `InfoItem-module__gap-16___gJVPs`,
	"gap18": `InfoItem-module__gap-18___SFZVq`,
	"gap20": `InfoItem-module__gap-20___LUV3m`,
	"gap24": `InfoItem-module__gap-24___hNPcf`,
	"gap26": `InfoItem-module__gap-26___oGMCp`,
	"gap30": `InfoItem-module__gap-30___tHoB6`,
	"gap32": `InfoItem-module__gap-32___zfpsq`,
	"gap40": `InfoItem-module__gap-40___AtefC`,
	"gap50": `InfoItem-module__gap-50___EeTiC`,
	"flex1": `InfoItem-module__flex-1___hCY0B`,
	"flexNone": `InfoItem-module__flex-none___Dzac5`,
	"flexColumn": `InfoItem-module__flex-column___kG5g_`,
	"flexRow": `InfoItem-module__flex-row___z9AwR`,
	"verticallyCentered": `InfoItem-module__vertically-centered___BmYl4`,
	"horizontallyCentered": `InfoItem-module__horizontally-centered___IgM7R`,
	"horizontallyEnd": `InfoItem-module__horizontally-end___mDTqJ`,
	"verticallyStart": `InfoItem-module__vertically-start___aCrbC`,
	"spaceBetween": `InfoItem-module__space-between___vMZbR`,
	"flexWrap": `InfoItem-module__flex-wrap___Kf_Sd`,
	"height100": `InfoItem-module__height-100___ZOjy0`,
	"width50": `InfoItem-module__width-50___By_Uy`,
	"width100": `InfoItem-module__width-100___VWemy`,
	"cursorPointer": `InfoItem-module__cursor-pointer___L3dAE`,
	"cursorNotAllowed": `InfoItem-module__cursor-not-allowed___j2rV6`,
	"absoluteCentered": `InfoItem-module__absolute-centered___clwzP`,
	"absolute": `InfoItem-module__absolute___wfTak`,
	"relative": `InfoItem-module__relative___GEf6u`,
	"fixed": `InfoItem-module__fixed___M9UBk`,
	"visible": `InfoItem-module__visible___MqqTg`,
	"invisible": `InfoItem-module__invisible___qqrv0`,
	"col90": `InfoItem-module__col-90___G0MrI`,
	"colAuto": `InfoItem-module__col-auto___w7B8O`,
	"medicalTabs": `InfoItem-module__medical-tabs___fyfhN`,
	"medicalTableNew": `InfoItem-module__medical-table-new____Wi5W`,
	"noPagination": `InfoItem-module__no-pagination___Gd49b`,
	"medicalTableEmpty": `InfoItem-module__medical-table-empty___Q_JH2`,
	"iconBtn": `InfoItem-module__icon-btn___WXitQ`,
	"searchIcon": `InfoItem-module__search-icon___aLMM2`,
	"disableSelect": `InfoItem-module__disable-select___sxnoY`,
	"breakWord": `InfoItem-module__break-word___CcD0N`,
	"popupClearBtn": `InfoItem-module__popup-clear-btn___MXE82`,
	"scrollMB20": `InfoItem-module__scroll-m-b-20___vMCNW`,
	"title": `InfoItem-module__title___o39sw`,
	"content": `InfoItem-module__content___vOAYA`,
	"suffix": `InfoItem-module__suffix___iKDWS`,
	"tooltipIcon": `InfoItem-module__tooltipIcon___q5m1C`
};
module.exports = ___CSS_LOADER_EXPORT___;
